module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAQCAMAAAD+iNU2AAAAAXNSR0IB2cksfwAAAEhQTFRFAAAASkpKS0tLSkpKS0tLSkpKTExMSEhIUFBQS0tLSkpKTU1NSkpKS0tLTU1NS0tLS0tLTExMS0tLTExMS0tLS0tLS0tLS0tLJE8RwQAAABh0Uk5TAGCPwP8wbyAQX38/kKBQv/CA4EBw39DvaXg7xQAAAGpJREFUeJyNzNsWgyAMRNGxGQQtKPHS/v+fNuAq2LeeJ3YCALXhgZ+Ef9uNoy8O0/w0RpKpeLHDCjCrurpX3biDAhxOGOYAvex5CoXL10j2lK+2rwNjN2Iy3nwVzZlr602HIbOn5dbesj8+1poFQLtngqAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./app/images/import_default.png
// module id = 260
// module chunks = 0